import * as React from "react";
import { Component, Fragment } from "react";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";

class WorkInProgress extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardTitle title="Что-то" />
          <CardText>
            <p>Скоро здесь что-то будет.</p>
            {/* <p>
              Мир присутствия высвобождает таким образом сущее, которое не
              только отлично от средств и вещей вообще, но сообразно своему роду
              бытия в качестве присутствия само существует, способом
              бытия-в-мире, «в» таком мире, в каком оно еще и внутримирно
              встречно. Это сущее ни налично ни подручно, а существует так же,
              как само высвобождающее присутствие – оно тоже-и со-присутствует.
              Захоти мы тогда уж и мир вообще идентифицировать с внутримирно
              сущим, то надо было бы сказать, что «мир» есть тоже присутствие.
            </p> */}
          </CardText>
        </Card>
      </Fragment>
    );
  }
}

export default WorkInProgress;



// WEBPACK FOOTER //
// ./src/components/pages/special/WorkInProgress.tsx